import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const RouteProtectionTest = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Route Protection Test</h1>
      
      <div style={{ marginBottom: '20px' }}>
        <h2>Current User Status</h2>
        {user ? (
          <div>
            <p><strong>Logged in:</strong> Yes</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Name:</strong> {user.name}</p>
            <p><strong>Is Admin:</strong> {user.isAdmin || user.is_admin ? 'Yes' : 'No'}</p>
            <button onClick={handleLogout} style={{ padding: '10px 20px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
              Logout
            </button>
          </div>
        ) : (
          <p><strong>Logged in:</strong> No</p>
        )}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h2>Route Access Test</h2>
        <p>Try accessing these routes to test protection:</p>
        
        <h3>Regular User Routes (Require Login)</h3>
        <ul>
          <li><a href="/fullchat">/fullchat</a> - Should work if logged in</li>
          <li><a href="/profile">/profile</a> - Should work if logged in</li>
        </ul>

        <h3>Admin Only Routes (Require Admin + Login)</h3>
        <ul>
          <li><a href="/analytics">/analytics</a> - Should only work if admin</li>
          <li><a href="/userlist">/userlist</a> - Should only work if admin</li>
          <li><a href="/online-users">/online-users</a> - Should only work if admin</li>
        </ul>

        <h3>Public Routes</h3>
        <ul>
          <li><a href="/">/ (Home)</a> - Should always work</li>
          <li><a href="/login">/login</a> - Should always work</li>
        </ul>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h2>Test Instructions</h2>
        <ol>
          <li>Try accessing protected routes while logged out - should redirect to login</li>
          <li>Login as regular user - should be able to access user routes but not admin routes</li>
          <li>Login as admin - should be able to access all routes</li>
          <li>Test logout - should clear session and redirect to login</li>
        </ol>
      </div>

      <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px' }}>
        <h3>Demo Credentials</h3>
        <p><strong>Regular User:</strong> any email / any password</p>
        <p><strong>Admin User:</strong> admin@oaklandai.com / any password</p>
      </div>
    </div>
  );
};

export default RouteProtectionTest;
